const SECURE_TYPES = ['password'];

const FORM_INPUTS_SELECTOR = 'input:not([type=submit]),select,textarea';

export const formValuesToJSON = (formEl: HTMLFormElement): Record<string, unknown> => {
  const nodes = formEl.querySelectorAll<HTMLInputElement>(FORM_INPUTS_SELECTOR);
  return [...nodes].reduce<Record<string, unknown>>((memo, node) => {
    const key = `user.${node.getAttribute('name')}`;
    const existingValueForKey = memo[key];

    let value: unknown;
    const type = node.getAttribute('type');
    if (type === 'checkbox') {
      // handle checkbox & radio as array;
      value = existingValueForKey || [];
      if (node.checked) {
        value = (value as unknown[]).concat([node.value]);
      }
    } else if (type === 'radio') {
      value = node.checked && node.value;
    } else if (type !== null && SECURE_TYPES.includes(type)) {
      value = '';
    } else {
      value = node.value;
    }

    return !value
      ? memo
      : {
          ...memo,
          [key]: value,
        };
  }, {});
};

export function secureValues(formElement: HTMLElement): Record<string, unknown> {
  const nodes = formElement.querySelectorAll<HTMLInputElement>(FORM_INPUTS_SELECTOR);
  return [...nodes].reduce((memo, node) => {
    const type = node.getAttribute('type');
    const values: Record<string, string> = {};

    if (type === 'password') {
      const key = `form.${node.name}`;
      values[key] = node.value;
    }

    return !values
      ? memo
      : {
          ...memo,
          values,
        };
  }, {});
}
